import { Logger } from '@/legacy/api/Logger';

export class GroupTabLogger extends Logger {
    channel = 'GroupTab';
    constructor(pageName = null) {
        super();
        if (pageName) {
            this.channel = `${this.channel}.${pageName}`;
        }
    }
    info(message, context = {}) {
        const {_message, _context } = this.getData(message, context);
        super.info(this.channel, _message, _context);
    }

    error(message, context = {}) {
        // TODO: Blacklist errors we don't care about
        const {_message, _context } = this.getData(message, context);
        super.error(this.channel, _message, _context);
    }

    critical(message, context = {}) {
        const { _message, _context } = this.getData(message, context);
        super.critical(this.channel, _message, _context);
    }

    getData(message, context = {}) {
        if (context === null || typeof context !== 'object') {
            console.warn("Logger context must be of type object. Was ", context);
            context = {};
        }
        context.orderId = Mobi2Go.Order.getId();
        context.groupTabId = Mobi2Go.Customer.getCurrentGroupTab()?.id;
        context.headoffice = `${Mobi2Go.headoffice.domain_name}[${Mobi2Go.headoffice.id}]`;
        context.location = `${Mobi2Go.Order.getLocation().name}[${Mobi2Go.Order.getLocation().id}]`;

        return {
            _message: message,
            _context: context
        }
    }
}
